export default "__VITE_PUBLIC_ASSET__9a53e118__"